module.exports = __webpack_public_path__ + "img/定制开发1.6b240ba9.png";